export default (function (string) {
  return string ? !/\d/.test(string) : true;
});